import { EFFECT_CONTENT_TYPE } from '@Constants/dataEnums';

/** 共用：變更單基本資訊 */
const baseEffect = {
    effectID: 1001,
    effectNo: 'EF20240001',
    effectStatus: 0,
    effectStatusText: '未生效',
    effectCreateDate: '2026-05-29T00:00:00',
    effectDate: '2026-07-01T00:00:00',
    cycleOrderID: 1,
    employeeID: 5,
    employeeName: 'Sabrina',
};

/** ITEMS (1)：商品口味數量 */
export const mockItems = {
    ...baseEffect,
    effectType: [EFFECT_CONTENT_TYPE.ITEMS],
    items: [
        { productID: 101, productName: '乳清蛋白(綜合口味)-BCAA升級', quantity: 2, salePrice: 1450 },
        { productID: 102, productName: '乳清蛋白(宇治抹茶)-BCAA升級', quantity: 1, salePrice: 1450 },
    ],
};

/** SHIPPINGDAY (2)：出貨週期 */
export const mockShippingDay = {
    ...baseEffect,
    effectType: [EFFECT_CONTENT_TYPE.SHIPPINGDAY],
    shippingDayText: '每 20 日',
};

/** RECEIVER (4)：收件資訊 */
export const mockReceiver = {
    ...baseEffect,
    effectType: [EFFECT_CONTENT_TYPE.RECEIVER],
    receiverName: '王小明',
    receiverMobile: '0912345678',
    receiverPostCode: '106',
    receiverAddress: '台北市大安區忠孝東路四段 1 號',
    receiverNotes: '請放在門口',
};

/** STOP (16)：暫停 */
export const mockStop = {
    ...baseEffect,
    effectType: [EFFECT_CONTENT_TYPE.STOP],
    suspendStartDate: '2026-07-01T00:00:00',
    suspendEndDate: '2026-07-31T00:00:00',
    suspendReasonText: '其他',
    suspendNote: '出國旅遊暫時不需要',
};

/** STOP - 無補充說明 */
export const mockStopNoNote = {
    ...baseEffect,
    effectType: [EFFECT_CONTENT_TYPE.STOP],
    suspendStartDate: '2026-07-01T00:00:00',
    suspendEndDate: '2026-08-31T00:00:00',
    suspendReasonText: '健康因素',
    suspendNote: null,
};

/** QUIT (32)：退訂 */
export const mockQuit = {
    ...baseEffect,
    effectType: [EFFECT_CONTENT_TYPE.QUIT],
    unsubscribeDate: '2026-07-01T00:00:00',
    unsubscribeReasonText: '不再需要此服務',
    unsubscribeNote: '謝謝您的服務',
};

/** RESTOP (64)：回復暫停 */
export const mockReStop = {
    ...baseEffect,
    effectType: [EFFECT_CONTENT_TYPE.RESTOP],
    originalSuspendStartDate: '2026-07-01T00:00:00',
    originalSuspendEndDate: '2026-07-31T00:00:00',
    reSuspendDate: '2026-08-01T00:00:00',
};

/** CHANGEITEMS (256)：LINE-OA 商品口味數量 */
export const mockChangeItems = {
    ...baseEffect,
    effectType: [EFFECT_CONTENT_TYPE.CHANGEITEMS],
    items: [
        { productID: 103, productName: '鈣力嗨', quantity: 1, salePrice: 940 },
    ],
};

/** 複合：商品 + 出貨週期同時變更 */
export const mockItemsAndShipping = {
    ...baseEffect,
    effectType: [EFFECT_CONTENT_TYPE.ITEMS, EFFECT_CONTENT_TYPE.SHIPPINGDAY],
    items: [
        { productID: 101, productName: '乳清蛋白(綜合口味)-BCAA升級', quantity: 3, salePrice: 1450 },
    ],
    shippingDayText: '每 10 日',
};

/** 所有場景清單（供 Preview 頁迭代） */
export const ALL_MOCK_SCENARIOS = [
    { label: 'ITEMS — 商品口味數量',          data: mockItems },
    { label: 'SHIPPINGDAY — 出貨週期',        data: mockShippingDay },
    { label: 'RECEIVER — 收件資訊',           data: mockReceiver },
    { label: 'STOP — 暫停（含補充說明）',      data: mockStop },
    { label: 'STOP — 暫停（無補充說明）',      data: mockStopNoNote },
    { label: 'QUIT — 退訂',                   data: mockQuit },
    { label: 'RESTOP — 回復暫停',             data: mockReStop },
    { label: 'CHANGEITEMS — LINE-OA 商品',    data: mockChangeItems },
    { label: 'ITEMS + SHIPPINGDAY — 複合變更', data: mockItemsAndShipping },
];
